var map = {
	"./music-instructions.json": 5492,
	"./music-library-intro2024.json": 5493,
	"./music-library-launch2024.json": 5494,
	"./music-progression.json": 5495,
	"./startSourcesAdvanced.json": 5496,
	"./startSourcesSimple.json": 5497,
	"./startSourcesSimple2.json": 5498,
	"./startSourcesTracks.json": 5499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5054;